<nav class="survey-nav" role="navigation" aria-label="Admin main navigation">
  <div class="survey-nav__inner">
    <a class="survey-nav__brand" routerLink="/admin/survey-types" routerLinkActive="survey-nav__link--active" [routerLinkActiveOptions]="{ exact: true }">
      Survey Admin
    </a>
    <ul class="survey-nav__list" role="menubar">
      <li role="none">
        <a class="survey-nav__link" role="menuitem" routerLink="/admin/survey-types" routerLinkActive="survey-nav__link--active">
          Survey Types
        </a>
      </li>
      <li role="none">
        <a class="survey-nav__link" role="menuitem" routerLink="/admin/survey-types/create" routerLinkActive="survey-nav__link--active">
          Create Survey
        </a>
      </li>
      <li role="none">
        <a class="survey-nav__link" role="menuitem" routerLink="/admin/user-voice" routerLinkActive="survey-nav__link--active">
          User voice
        </a>
      </li>
    </ul>
  </div>
</nav>
